var app = angular.module('leonardo');

var FormPriceWithCurrency = function() {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      maxlength: '=ngMaxLength',
      minlength: '=ngMinlength',
      blur: '&ngBlur',
      focus: '&ngFocus',
      onSubmit: '&',
      label: '@',
      placeholder: '@',
      symbol: '=?',
      fractionSize: '=?'
    },
    templateUrl: 'views/templates/form/form-price-with-currency.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      
      scope.currencyCode = !isNull(scope.symbol) ? angular.copy(scope.symbol) : 'USD';

      scope.$watch('value', function (value) {
        value = !isNull(value) ? value.replace(/[,]/g, '') : '0';
        var value_num = !isNull(value) ? value.replace(" " + scope.currencyCode, "") : '0';
        scope.ngModelCtrl.$setViewValue(parseFloat(value_num));
      });

      scope.ngModelCtrl.$render = function () {
        var num = parseFloat(scope.ngModelCtrl.$viewValue);
        scope.value = !isNull(num) ? num.toString() : '';
      };

      element.find('input').bind("keydown keypress", function (e) {
        const maxCharacters = parseInt(scope.maxlength) || 17;
        const integerSize = 10;
        const decimalSize = 6;
        if (![8,37,38,39,40,46,190].includes(e.keyCode)) {
          if (e.keyCode === 13) {
            scope.$apply(function () {
                scope.onSubmit();
              });
              e.preventDefault();
          } else {
            const idx = e.target.selectionStart;
            const number = e.currentTarget.value.split(' ' + scope.currencyCode);
            const fraction = number.length ? number[0].split('.') : [];
            if (number && number.length >= maxCharacters) {
              e.preventDefault();
            }
            if (fraction.length > 0 && idx <= fraction[0].length && fraction[0].length >= integerSize) {
              e.preventDefault();
            }
            if (fraction.length > 1 && idx > fraction[0].length && fraction[fraction.length - 1].length >= decimalSize) {
              e.preventDefault();
            }
          }
        }
      });

      scope.$watch('symbol', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          scope.currencyCode = !isNull(newValue) ? angular.copy(newValue) : 'USD';
        }
      });
    }
  };
};

app.directive('formPriceWithCurrency', [FormPriceWithCurrency]);
